import React, {useState} from 'react'
import '../App.css'
import ChatModal from './ChatModal'

function ChatBar(props) {
    const [value, setValue] = useState("");
    
    const handleChange = (e) => {
        setValue(e.target.value);
    }

    const handleButtonClick = (e) => {
        if (value) {
            props.sendMessage({type: "text", text: value});
            setValue("");
        }
        else if (!props.showChatModal) {
            e.stopPropagation();
            props.setShowChatModal(true);
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter')
            handleButtonClick();
    }

    return (
        <div className="chat-bar">
            <input type="text" value={value} onChange={handleChange} onKeyDown={handleKeyDown}
                disabled={props.isDisabled}
                placeholder={props.isDisabled?"此功能目前無法使用":"說點什麼吧..."}
                className="chat-bar__input"/>
            <div className={`chat-bar__button ${props.isDisabled?"disabled":""}`} onClick={handleButtonClick} >
                <div style={{backgroundImage: value?'url("/images/send.png")':'url("/images/menu.png")'}}/>
            </div>
            {props.showChatModal?<ChatModal sendMessage={props.sendMessage} setShowChatModal={props.setShowChatModal}></ChatModal>:null}
        </div>
    )
}

export default ChatBar;